module.exports = __webpack_public_path__ + "static/rahman_img.81a60f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rahman_img.png
// module id = 52
// module chunks = 7495967469674 35783957827783 247366825623556